import * as React from 'react';

import SpecialAlert from 'src/pages/ForgotPasswordView/components/Alert';
import Input from 'src/components/common/Input';
import TextArea from 'src/components/common/TextArea';
import Button from 'src/components/common/Button';
import AccountInfoHeader from '../AccountInfoHeader';
import AccountInfoFooter from '../AccountInfoFooter';

import CreditLimitService from 'src/services/creditLimit/CreditLimitService';
import env from 'src/shared/env';

import './AccountIncreaseCredit.scss';

interface IAccountIncreaseLimitState {
  name: string;
  accountNumber: string;
  companyName: string;
  email: string;
  phone: string;
  request: string;
  succeed: boolean;
  failed: boolean;
  alertMessage: string;
  t?: any;
}

class AccountIncreaseCredit extends React.Component<
  any,
  IAccountIncreaseLimitState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      name: '',
      accountNumber: '',
      companyName: '',
      email: '',
      phone: '',
      request: '',
      succeed: false,
      failed: false,
      alertMessage: ''
    };
  }

  private handleNameChange = (name: string) => {
    this.setState({ name });
  };

  private handleAccountNumberChange = (accountNumber: string) => {
    this.setState({ accountNumber });
  };

  private handleCompanyNameChange = (companyName: string) => {
    this.setState({ companyName });
  };

  private handleEmailChange = (email: string) => {
    this.setState({ email });
  };

  private handlePhoneChange = (phone: string) => {
    this.setState({ phone });
  };

  private handleRequestChange = (request: string) => {
    this.setState({ request });
  };

  private onSubmitForm = () => {
    const { t } = this.props;
    CreditLimitService.increaseCreditLimit(
      this.state.accountNumber,
      this.state.companyName,
      this.state.email,
      this.state.request,
      this.state.phone,
      this.state.name
    )
      .then(res =>
        this.setState({
          accountNumber: '',
          companyName: '',
          email: '',
          request: '',
          phone: '',
          name: '',
          succeed: true,
          failed: false,
          alertMessage: t('accountCreditLimitIncreaase.successMsgTxt')
        })
      )
      .catch(err => {
        this.setState({
          succeed: false,
          failed: true,
          alertMessage: err.response.data.message
        });
      });
  };

  private handleCloseAlert = () => {
    this.setState({ succeed: false, failed: false, alertMessage: '' });
  };

  public render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <AccountInfoHeader />
        <div className="rp-account-increase-credit">
          {(this.state.failed || this.state.succeed) && (
            <SpecialAlert
              className="rp-account-increase-credit--alert"
              icon={this.state.failed ? 'rpds-error' : 'rpds-check-circle'}
              type={this.state.failed ? 'error' : 'success'}
              onClose={this.handleCloseAlert}
            >
              {this.state.alertMessage.split('-').map(msg => (
                <p>{msg}</p>
              ))}
            </SpecialAlert>
          )}

          <div className="container-fluid">
            <div className="row">
              <h6 className="col-12 rp-account-increase-credit--title">
                {t('accountCreditLimitIncreaase.requestCreditLimitHeader')}
              </h6>
            </div>
            <div className="row rp-account-increase-credit--subtitle">
              <p className="col-12">
                {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                  ? `${t('accountCreditLimitIncreaase.descriptionCA')}`
                  : `${t('accountCreditLimitIncreaase.description')}`}
              </p>
              <p className="col-12">
                {t('accountCreditLimitIncreaase.completeFormTxt')}
              </p>
            </div>
          </div>
          <span className="rp-account-increase-credit--divider" />
          <div className="container-fluid">
            <div className="row">
              <Input
                className="col-12"
                label={t('accountCreditLimitIncreaase.name')}
                value={this.state.name}
                onChange={this.handleNameChange}
              />
            </div>
            <div className="row">
              <Input
                className="col-12 col-md-6"
                label={t('accountInfoHeader.accountNumber')}
                value={this.state.accountNumber}
                onChange={this.handleAccountNumberChange}
              />
              <Input
                className="col-12 col-md-6"
                label={t('accountCreditLimitIncreaase.companyName')}
                value={this.state.companyName}
                onChange={this.handleCompanyNameChange}
              />
            </div>
            <div className="row">
              <div className="col-12 col-md-6">
                <Input
                  label={t('common.email')}
                  value={this.state.email}
                  onChange={this.handleEmailChange}
                />
              </div>
              <div className="col-12 col-md-6">
                <Input
                  label={t('common.phone')}
                  value={this.state.phone}
                  onChange={this.handlePhoneChange}
                  instructions={t('accountCreditLimitIncreaase.noDashes')}
                />
              </div>
            </div>
            <div className="row">
              <TextArea
                className="col-12"
                label={t('accountCreditLimitIncreaase.creditLimitRequest')}
                value={this.state.request}
                onChange={this.handleRequestChange}
              />
            </div>
            <div className="row d-flex justify-content-end">
              <div className="rp-account-increase-credit--button">
                <Button
                  buttonClass={'primary-button'}
                  label={t(
                    'accountCreditLimitIncreaase.submitRequestActionTxt'
                  )}
                  action={this.onSubmitForm}
                />
              </div>
            </div>
          </div>
        </div>
        <AccountInfoFooter />
      </React.Fragment>
    );
  }
}

export default AccountIncreaseCredit;
